import React, { useRef, useEffect, useState } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Popover from '@material-ui/core/Popover';
import { ColorResult, SketchPicker } from 'react-color';
import {
  MobileDesignConfigClasses,
  SplashColorState
} from '../MobileDesignConfig.types';
import { Swatch, Input } from '../..';
import colorIcon from '../../../assets/pictures/colorIcon.png';

interface SplashColorSectionProps {
  classes: MobileDesignConfigClasses;
  colorState: SplashColorState;
  onTogglePicker: () => void;
  onInputChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onPickerChange: (color: ColorResult) => void;
}

export const SplashColorSection: React.FC<SplashColorSectionProps> = ({
  classes,
  colorState,
  onTogglePicker,
  onInputChange,
  onPickerChange
}) => {
  const { displayColorPickerSplash, newSplashColor, backgroundSplash, splashValidationMessage } = colorState;
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const swatchRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (displayColorPickerSplash && swatchRef.current) {
      setAnchorEl(swatchRef.current);
    } else {
      setAnchorEl(null);
    }
  }, [displayColorPickerSplash]);

  const handleClose = () => {
    if (displayColorPickerSplash) {
      onTogglePicker();
    }
  };

  return (
    <div>
      <p className={classes.designText}>Couleur de fond du splash</p>
      <List>
        <ListItem key="splashBackgroundColor" className={classes.listItemStyle}>
          <ListItemIcon className={classes.iconColorStyle}>
            <div ref={swatchRef} style={{ display: 'inline-block' }}>
              <Swatch
                color={backgroundSplash || undefined}
                secondaryColor={newSplashColor}
                onClick={onTogglePicker}
              />
            </div>
            <Popover
              open={displayColorPickerSplash && Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              <SketchPicker
                color={newSplashColor}
                onChange={onPickerChange}
              />
            </Popover>
          </ListItemIcon>
          <ListItemText className={classes.listItemTextStyle}>
            <div className={classes.inputWrapper}>
              <Input
                margin="dense"
                type="text"
                id="splashBackgroundColor"
                variant="outlined"
                value={newSplashColor}
                onChange={onInputChange}
                className={classes.inputStyle}
                error={splashValidationMessage?.text === 'is-invalid'}
              />
            </div>
            <Typography variant="caption" className={classes.helperText}>
              Les modifications ne seront visibles qu'après une mise à jour de l'application. Pour plus d'informations, contactez le support.
            </Typography>
          </ListItemText>
          <ListItemIcon className={classes.colorIcon}>
            <img src={colorIcon} alt="" className={classes.imageWidth} />
          </ListItemIcon>
        </ListItem>
      </List>
    </div>
  );
};
